import {SortDirection} from "../common/models/table";
import {dictionariesUrls} from "../dictionaries/api/dictionariesApi";
import {timetablesUrls} from "../timetables/api/timetablesApi";
import {topologyUrls} from "../topology/api/topologyApi";
import {reportsUrls} from "../reports/api/reportsApi";
import {documentsUrls} from "../documents/api/documentsApi";
import {lightboardUrls, placeUrls} from "../place/api/placeApi";
import {administrationUrls} from "../administration/api/administrationApi";
import {userUrls} from "../common/api/userApi";
import {photosUrls, tcrUrls, transportationUrls} from "../transportation/api/transportationApi";
import {alertsUrls} from "../alerts/api/alertsApi";
import {priceListUrls} from "../priceList/api/priceListApi";

export const apiUrls = {
    dictionaries: dictionariesUrls,
    timetables: timetablesUrls,
    topology: topologyUrls,
    reports: reportsUrls,
    documents: documentsUrls,
    place: placeUrls,
    administration: administrationUrls,
    user: userUrls,
    transportation: transportationUrls,
    alerts: alertsUrls,
    lightboard: lightboardUrls,
    photos: photosUrls,
    tcr: tcrUrls,
    priceList: priceListUrls
};

export interface SortingAndFilteringParams {
    orderBy?: string;
    sortDirection?: SortDirection;
    filterCondition?: string;
}

export interface PaginationParams {
    offset?: number;
    size?: number;
}

export class Api {
    public static getUrl(endpoint: string): string {
        return `${window._env_.API_URL}/${endpoint}`;
    }

    public static isSuccess(response: any) {
        return !response || response?.status < 300;
    }

    public static addSortingAndFilteringParams(request: string, sortingAndFilteringParams?: SortingAndFilteringParams): string {
        if (!sortingAndFilteringParams) {
            return request;
        }

        let resultUrl = request;
        const orderBy = sortingAndFilteringParams.orderBy;
        const sortDirection = sortingAndFilteringParams.sortDirection;
        const filterCondition = sortingAndFilteringParams.filterCondition;

        if (orderBy && sortDirection) {
            resultUrl = this.addParams(resultUrl, `sort=${orderBy}::${sortDirection.toUpperCase()}`);
        }

        if (filterCondition) {
            resultUrl = this.addParams(resultUrl, `query=${filterCondition}`);
        }

        return resultUrl;
    }

    public static addPaginationParams(request: string, paginationParams: PaginationParams): string {
        if (!paginationParams || paginationParams.size === null || paginationParams.size === undefined ||
            paginationParams.offset === null || paginationParams.offset === undefined) {
            return request;
        }

        return this.addParams(request, `size=${paginationParams.size}&offset=${paginationParams.offset}`);
    }

    public static addParams(request: string, params: string): string {
        if (!request || !params) {
            return request;
        }

        let resultUrl = request;

        if (request.includes("?")) {
            resultUrl = `${resultUrl}&${params}`;
        } else {
            if (request.slice(-1) === "/") {
                resultUrl = `${resultUrl}?${params}`;
            } else {
                resultUrl = `${resultUrl}/?${params}`;
            }
        }

        return resultUrl;
    }
}
